import { doc, getDoc, getFirestore, FirestoreError } from 'firebase/firestore';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
// @ld
import { IPublicOrganisationRead } from '@ld/utils';

export const PUBLIC_ORGANISATIONS = 'public_organisations';

export const publicOrganisationQueryKey = (slug?: string) => [PUBLIC_ORGANISATIONS, slug];

export const usePublicOrganisation = (
  slug?: string,
  options?: Omit<
    UseQueryOptions<IPublicOrganisationRead | undefined, FirestoreError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<IPublicOrganisationRead | undefined, FirestoreError>({
    ...options,
    queryKey: publicOrganisationQueryKey(slug),
    queryFn: async () => {
      if (!slug) return undefined;
      const snap = await getDoc(doc(getFirestore(), PUBLIC_ORGANISATIONS, slug));
      if (!snap.exists()) return undefined;
      return { id: snap.id, ...snap.data() } as IPublicOrganisationRead;
    },
    enabled: !!slug && options?.enabled !== false
  });
